export enum EEirSalesNLEStatus {
    ERROR = "ERROR",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
}

export enum EEirSalesViewAvailableAppointmentsStatus {
    PENDING = "PENDING",
    PENDING_TIMEOUT = "PENDING_TIMEOUT",
    REJECTED = "REJECTED",
    SUCCESS = "SUCCESS",
}
